import { render, staticRenderFns } from "./AISlideGeneratorSideLeft.vue?vue&type=template&id=fed6bf30&scoped=true&"
import script from "./AISlideGeneratorSideLeft.vue?vue&type=script&lang=js&"
export * from "./AISlideGeneratorSideLeft.vue?vue&type=script&lang=js&"
import style0 from "./AISlideGeneratorSideLeft.vue?vue&type=style&index=0&id=fed6bf30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed6bf30",
  null
  
)

export default component.exports